import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Loader";

const AllCategories = () => {
  const [categories, setCategories] = useState();
  const [loading, setLoading] = useState();
  const [uichange, setuichange] = useState(false);
  const navigate = useNavigate();
  const [allCategories, setAllCategories] = useState();

  const getAllCategories = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/category/");
      setLoading(false);
      if (response.data.success) {
        setCategories(response.data.categories);
        setAllCategories(response.data.categories);
        console.log(allCategories);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, [uichange]);

  const handleChange = (e) => {
    let s = e.target.value.toLowerCase();
    if (s === "") {
      setAllCategories(categories);
    } else {
      setAllCategories([])
      const filteredCategories = categories.filter((category) => {
        return category?.title.toLowerCase().includes(s);
      })
      setAllCategories(filteredCategories);
    }
  }

  //   const deletecategory = async (id) => {
  //     try {
  //       console.log("delete :", id);
  //       let agree = window.confirm("Are you sure, want to delete this category?");

  //       if (agree) {
  //         const response = await axios.delete(`/category/delete/${id}`);

  //         if (response.data.success) {
  //           setuichange(!uichange);
  //           toast.success(response.data.message);
  //         }
  //       } else {
  //         return;
  //       }
  //     } catch (error) {
  //       console.log(error);
  //       toast.error(error.response.data.message);
  //     }
  //   };

  // handling delete user

  const handleDelete = async (id) => {
    try {
      const isConfirmed = await showConfirmBox();

      if (isConfirmed) {
        setLoading(true);
        const response = await axios.delete(`/category/${id}`);
        if (response.data.success) {
          setLoading(false);
          toast.success(response.data.message);
          setuichange(!uichange);
        }
        setLoading(false);
      }
    } catch (error) {
      console.log("Error while deleting", error);
      setLoading(false);
      toast.error(error.response?.data?.message || "Error deleting user");
    }
  };

  function showConfirmBox() {
    return new Promise((resolve) => {
      console.log("Showing confirmation dialog");
      document.getElementById("confirmDialog").classList.remove("hidden");

      const handleConfirm = (isConfirmed) => {
        resolve(isConfirmed);
        closeConfirmBox();
      };

      document.getElementById("confirmYes").onclick = () => handleConfirm(true);
      document.getElementById("confirmNo").onclick = () => handleConfirm(false);
    });
  }

  function closeConfirmBox() {
    console.log("Closing confirmation dialog");
    document.getElementById("confirmDialog").classList.add("hidden");
  }

  if (loading === true) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      {!allCategories ? (
        <h1 className="bg-red-300 p-3 rounded-lg text-3xl mt-2 mx-2 text-white">
          Categories not available
        </h1>
      ) : (
        <>
          <div className="overflow-x-auto mt-5">
            <div className="flex justify-center">
              <input
                type="search"
                placeholder="Search"
                onChange={handleChange}
                className="w-[20vw] h-12 p-4 rounded-lg border-2 border-blue-600 focus:border-none"
              />

            </div>
            <table className="table w-[95%] mx-auto mt-7 overflow-x-auto">
              {/* head */}
              <thead className="bg-blue-800 text-white">
                <tr className="text-lg">
                  <th></th>
                  <th>Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              {allCategories?.map((category, index) => {
                return (
                  <>
                    <tbody className="border-2 border-blue-400">
                      {/* row 1 */}
                      <tr className="text-base cursor-pointer hover:bg-blue-100">
                        <th className=" text-black font-bold">
                          {index + 1}
                        </th>
                        <td className=" text-blue-700 font-bold">
                          {category?.title}
                        </td>
                        <td>
                          <i
                            onClick={() =>
                              navigate(`/category/update/${category._id}`)
                            }
                            class="fa-solid fa-pen-to-square hover:scale-125 bg-green-700 text-white p-3 rounded-full cursor-pointer mr-5"
                          ></i>

                          <i
                            onClick={() => handleDelete(category._id)}
                            class="fa-solid fa-trash hover:scale-125 bg-red-500 text-white p-3 rounded-full cursor-pointer"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </>
                );
              })}
            </table>
          </div>
        </>
      )}

      {/* confirmation box */}
      <div id="confirmDialog" class="absolute  top-0 right-0 hidden ">
        <div class="bg-gray-300 p-6 rounded-lg shadow-lg text-center">
          <h2 class="text-xl font-semibold mb-4">Confirmation</h2>
          <p class="mb-6">Are you sure you want to delete?</p>
          <div class="flex justify-center gap-4">
            <button
              id="confirmYes"
              class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
              Yes
            </button>
            <button
              id="confirmNo"
              class="btn btn-primary text-white px-4 py-2 rounded hover:bg-gray-400"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllCategories;
